<template>
  <div>
    <v-container>
      <v-row v-if="game.state == 'created' && game.checkInEnabled">
        <v-col>
          <v-btn :disabled="loading" @click="startGameCheckIn" class="primary">
            <v-icon left>mdi-play</v-icon>{{$t('gamesettings.open-checkin')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="(game.state == 'created' && !game.checkInEnabled) || (game.state == 'checkin' && game.checkInEnabled)">
        <v-col>
          <v-btn :disabled="loading" @click="startGame" class="primary">
            <v-icon left>mdi-play</v-icon>{{$t('gamesettings.start-competition')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="game.state == 'active' && game.manualNextRound">
        <v-col>
          <v-btn :disabled="loading" @click="startNextRound" class="primary">
            <v-icon left>mdi-skip-next</v-icon>{{$t('gamesettings.end-current-round')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <share-link-widget
            v-if="game.bracketLink"
            i18n-key="common.share-bracket-link"
            :link="game.bracketLink"
            :subject="$t('common.bracket-link-subject', {competition: this.game.name})"
            :disabled="!game.youAreAdmin"/>
        </v-col>
      </v-row>
      <v-btn
          v-if="game.youAreAdmin"
          color="primary"
          :disabled="isReminderMailSent"
          @click="sendReminderMail"
      >
        Check-In Reminder Mail <v-icon v-if="isReminderMailSent" class="ml-2">mdi-check</v-icon>
      </v-btn>
      <v-row class="mt-5">
        <confirm-dialog
          v-if="showDeleteConfirmation"
          :visible="showDeleteConfirmation"
          :title="$t('gamesettings.deleteCompetition.title')"
          :text="$t('gamesettings.deleteCompetition.confirm-text')"
          confirmButtonClasses="error"
          :closeAction="function() {showDeleteConfirmation = false;}"
          :confirmAction="deleteGame"
        ></confirm-dialog>
        <v-col>
          <v-btn color="error" :disabled="loading" @click="openDeleteConfirmationDialog">
            <v-icon left>mdi-delete</v-icon>{{$t('gamesettings.deleteCompetition.title')}}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ConfirmDialog from "@/widgets/ConfirmDialog";
import {
  MUTATION_RAISE_NOTIFICATION,
  ACTION_RELOAD_ACTIVE_GAMES
} from "@/plugins/store";
import {
  EVENT_REFRESH_DATA,
  EVENT_GAMEINSTANCE_UPDATED
} from "@/plugins/eventbus";
import ShareLinkWidget from './ShareLinkWidget.vue';

export default {
  name: "GameSettings",
  components: {
    ConfirmDialog,
    ShareLinkWidget,
  },
  props: {
    game: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      loading: false,
      confirmFinishGame: false,
      showDeleteConfirmation: false,
      isReminderMailSent: false,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    sendReminderMail(){
      this.isReminderMailSent = true
      this.loading = true;
      this.$api
      .sendCheckinReminder(this.game.uid)
      .then(response => {
        this.loading = false;
        this.isReminderMailSent = true
        this.$eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, response.data);
      })
      .catch(error => {
        this.loading = false;
        this.$common.onError(error)
      })
    },
    startGame() {
      this.loading = true;
      this.$api
        .startGame(this.game.uid)
        .then(response => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: this.$t('competition.started-successfully'),
            type: "success"
          });
          this.$eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, response.data);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    startGameCheckIn() {
      if(!this.game.youAreAdmin){
        return
      }
      this.loading = true;
      this.$api
        .startGameCheckIn(this.game.uid)
        .then(response => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: this.$t('competition.checkin-opened-success'),
            type: "success"
          });
          this.$eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, response.data);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    startNextRound() {
      this.loading = true;
      this.$api.startNextRound(this.game.uid)
        .then(() => {
        this.loading = false;
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
          message: `Aktuelle Runde erfolgreich beendet`,
          type: "success"
        });
        this.$eventBus.$emit(EVENT_REFRESH_DATA);
      })
      .catch(error => {
        this.loading = false;
        this.$common.onError(error)
      });
    },
    openConfirmFinishGame() {
      this.confirmFinishGame = true;
    },
    finishGame() {
      this.loading = true;
      this.$api
        .finishGame(this.game.uid)
        .then(response => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: `Wettkampf erfolgreich beendet`,
            type: "success"
          });
          this.$eventBus.$emit(EVENT_REFRESH_DATA);
          this.$eventBus.$emit(EVENT_GAMEINSTANCE_UPDATED, response.data);
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    },
    openDeleteConfirmationDialog() {
      this.showDeleteConfirmation = true;
    },
    deleteGame() {
      this.dialog = false;
      this.loading = true;
      this.$api
        .deleteGame(this.game.uid)
        .then(() => {
          this.loading = false;
          this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            message: `Wettkampf erfolgreich gelöscht`,
            type: "success"
          });
          this.$store.dispatch(ACTION_RELOAD_ACTIVE_GAMES);
          this.$router.push("/dashboard");
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    }
  }
};
</script>
